import logo from "../assets/logo.png";
import "./Landing_header.css";
import { Link } from "react-router-dom";

function Landing_header() {
  return (
    <header className="landing_header">
      <img className="header_logo" src={logo} alt="Happer LOGO" />
      <h4 className="happer">Happer</h4>
      <div className="space_div"></div>
      <Link to="/signup_brand">
        <p className="left_text">Marque</p>
      </Link>
      <div
        style={{
          width: "1.7px",
          height: "93%",
          backgroundColor: "#c4c4c4",
        }}
      />
      <Link to="/signup_influencer">
        <p className="right_text">Influenceur</p>
      </Link>
    </header>
  );
}

export default Landing_header;
